import FavoriteButtonIcon from "./favorite-button-icon";
import FavoriteButtonText from "./favorite-button-text";

const favoriteButtonType = {
    icon: FavoriteButtonIcon,
    text: FavoriteButtonText
}


export default favoriteButtonType;